<ng-container *ngIf="isPopulated">
  <!-- 1 column - 3 CSS cols -->
  <div edsRow class="print-hidden">
    <div
      *ngIf="assets?.length > 0"
      edsCol
      [columnNumbers]="{ s: '4', l: '5' }"
      edsSpacing="md"
    >
      <eds-panel
        theme="white"
        class="list-details"
        [hasBorders]="true"
        [hasPadding]="true"
      >
        <eds-proximal placement="AssetsProximalTop"></eds-proximal>

        <eds-section-header
          [level]="3"
          [isLight]="true"
          theme="primary"
          size="h6"
          caveatPlacement="PortfolioAssets"
          edsSpacing="md"
          [asOfLabel]="'products.as-of' | translate"
          [asOfDate]="assetsFreq?.asOfDate"
          [updateFrequency]="assetsFreq?.updateFrequency"
        >
          {{ "products.portfolio-assets-section-title" | translate: fundId }}
        </eds-section-header>

        <ft-benchmark-table
          *ngIf="assetsBenchmark; else assetsCols"
          [fundId]="fundId"
          [benchmark]="assetsBenchmark"
          [rows]="assetsRows"
        ></ft-benchmark-table>

        <ng-template #assetsCols>
          <div edsCssCols maxCols="3" colGap="xxl">
            <!-- Info Items -->
            <eds-info-item
              *ngFor="let item of assets"
              [info]="item"
              edsSpacing="xs"
            ></eds-info-item>
          </div>
        </ng-template>

        <eds-proximal placement="AssetsProximalBottom"></eds-proximal>
      </eds-panel>
    </div>
    <div
      *ngIf="showPositionsPanel"
      edsCol
      [columnNumbers]="{ s: '4', l: '5' }"
      edsSpacing="md"
    >
      <eds-panel
        theme="white"
        class="list-details"
        [hasBorders]="true"
        [hasPadding]="true"
      >
        <eds-proximal placement="PositionsProximalTop"></eds-proximal>

        <eds-section-header
          [level]="3"
          [isLight]="true"
          theme="primary"
          size="h6"
          caveatPlacement="PortfolioPositions"
          edsSpacing="md"
          [asOfLabel]="'products.as-of' | translate"
          [asOfDate]="positionsFreq?.asOfDate"
          [updateFrequency]="positionsFreq?.updateFrequency"
        >
          {{ "products.portfolio-positions-section-title" | translate: fundId }}
        </eds-section-header>

        <ft-benchmark-table
          *ngIf="positionsBenchmark; else positionsCols"
          [fundId]="fundId"
          [benchmark]="positionsBenchmark"
          [rows]="positionsRows"
        ></ft-benchmark-table>

        <ng-template #positionsCols>
          <div edsCssCols maxCols="3" colGap="xxl">
            <!-- Info Items -->
            <eds-info-item
              *ngFor="let item of positions"
              [info]="item"
              edsSpacing="xs"
            ></eds-info-item>
          </div>
        </ng-template>

        <button
          *ngIf="isDocumentAvailable"
          edsButton="secondary"
          [hasIcon]="true"
          size="normal"
          (click)="openDocument()"
        >
          <span class="ft__btn__txt"
            >{{ "products.download-pdf" | translate: fundId }}
          </span>
          <eds-icon type="download" size="small"></eds-icon>
        </button>

        <eds-proximal placement="PositionsProximalBottom"></eds-proximal>
      </eds-panel>
    </div>
  </div>
  <div
    class="print-hidden"
    *ngIf="mainStatistics?.length > 0"
    edsRow
    edsSpacing="lg"
  >
    <div edsCol [columnNumbers]="{ s: '4', l: '12' }">
      <eds-panel
        theme="white"
        class="list-details"
        [hasBorders]="true"
        [hasPadding]="true"
      >
        <eds-proximal placement="StatisticsProximalTop"></eds-proximal>

        <eds-section-header
          [level]="3"
          [isLight]="true"
          theme="primary"
          size="h6"
          caveatPlacement="PortfolioStatistics"
          edsSpacing="md"
          [asOfLabel]="'products.as-of' | translate"
          [asOfDate]="mainFreq?.asOfDate"
          [updateFrequency]="mainFreq?.updateFrequency"
        >
          {{
            "products.portfolio-statistics-section-title" | translate: fundId
          }}
        </eds-section-header>

        <div *ngIf="mainBenchmark; else mainCols" edsRow>
          <ft-benchmark-table
            edsCol
            [columnNumbers]="{ s: '4', l: '8' }"
            edsSpacing="md"
            [fundId]="fundId"
            [benchmark]="mainBenchmark"
            [rows]="mainRows"
          ></ft-benchmark-table>
        </div>

        <ng-template #mainCols>
          <div
            edsCssCols
            maxCols="2"
            colGap="xxl"
            edsPadding
            edsPaddingBottom="sm"
          >
            <!-- Info Items -->
            <eds-info-item
              *ngFor="let item of mainStatistics"
              [info]="item"
              edsSpacing="xs"
            ></eds-info-item>
          </div>
        </ng-template>
        <div edsRow *ngIf="showHistAvgeLifeMaturity">
          <ft-historic-weighted-average-table
            edsCol
            [columnNumbers]="{ s: '4', l: '5' }"
            edsSpacing="md"
            [portfolioHistoricWeightedRows]="portfolioHistoricWeightedRows"
          ></ft-historic-weighted-average-table>
        </div>

        <eds-proximal placement="StatisticsProximalBottom"></eds-proximal>
      </eds-panel>
    </div>
  </div>
</ng-container>
